import { useCallback, useState } from "react";
import { PageItem } from "~/features/chat/hooks/useDocList";

export const usePageSelection = (pages: PageItem[]) => {
  const [selectedPageId, setSelectedPageId] = useState<string | null>(null);

  const togglePageSelection = useCallback((pageId: string) => {
    setSelectedPageId((prev) => (prev === pageId ? null : pageId));
  }, []);

  const clearSelectedPages = useCallback(() => {
    setSelectedPageId(null);
  }, []);

  const selectedPage = pages.find((p) => p.pageId === selectedPageId) || null;
  const selectedPageNumber = selectedPage
    ? pages.findIndex((p) => p.pageId === selectedPageId) + 1
    : 0;

  return {
    selectedPage,
    selectedPageId,
    selectedPageNumber,
    togglePageSelection,
    clearSelectedPages,
  };
};
